import { createTracker } from 'usage-tracker';
import events from 'automation-contextual-components/events.yaml';
import { TrackableDefinitions } from 'automation-contextual-components/_internal/tracking/Trackables';
const tracker = createTracker({
  events
});
export let trackEvent = (trackableKey, extraEventProps = {}) => {
  if (trackableKey && TrackableDefinitions[trackableKey]) {
    const addExtraEventProps = TrackableDefinitions[trackableKey];

    if (addExtraEventProps) {
      const {
        eventType,
        eventProps
      } = addExtraEventProps(extraEventProps);
      tracker.track(eventType, eventProps);
    }
  }
};
export const trackingUtilsSettersForTesting = {
  setTrackEventForTesting: func => {
    trackEvent = func;
  }
};